"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Refresh = require("./Refresh");
Object.keys(_Refresh).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Refresh[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Refresh[key];
    }
  });
});